module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-bg",
    style: ({
      'background-image': _vm.backgroundPath
    })
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.getStaticPath(_vm.logoPath),
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "header-text hidden-md-down"
  }, [_vm._v(_vm._s(_vm.headerText) + "\n        ")]), _c('div', {
    staticClass: "right-header-content ml-auto"
  }, [_c('social-media-buttons', {
    staticClass: "hidden-md-down float-right mt-0",
    attrs: {
      "media-links": _vm.mediaLinks
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "issn hidden-sm-down"
  }, [_vm._v("Online ISSN: "), _c('strong', [_vm._v(_vm._s(_vm.issn))])]), _vm._v(" "), _c('button', {
    staticClass: "button-primary"
  }, [_vm._v("Submit Paper")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrapper",
    class: {
      fixed: _vm.scrolled
    },
    attrs: {
      "id": "navWrapper"
    }
  }, [_c('div', {
    staticClass: "container hidden-sm-down"
  }, [_c('header-nav')], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-container hidden-md-up",
    class: {
      scrolled: _vm.scrolled
    }
  }, [_c('header-nav')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9ad586"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-area/HeaderAreaComponent.vue
// module id = 1436
// module chunks = 1